import React, { Component } from "react"
import {Switch, Route, NavLink} from "react-router-dom"
import {Form} from './Form'
import {FormUpdate} from './FormUpdate'

export class DarePage extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return (
        <div className="card">
            <div className="card-body">
                <ul className="nav nav-tabs nav-tabs-info">
                    <li className="nav-item">
                        <NavLink to={`/mangarfamdygiinadmin/dare/GrandMother/`} exact className="nav-link"  activeClassName="active">GrandMother</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={`/mangarfamdygiinadmin/dare/GrandFather/`} exact className="nav-link"  activeClassName="active">GrandFather</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={`/mangarfamdygiinadmin/dare/Father/`} exact className="nav-link"  activeClassName="active">Father</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={`/mangarfamdygiinadmin/dare/Mother/`} exact className="nav-link"  activeClassName="active">Mother</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={`/mangarfamdygiinadmin/dare/Brother/`} exact className="nav-link"  activeClassName="active">Brother</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={`/mangarfamdygiinadmin/dare/Sister/`} exact className="nav-link"  activeClassName="active">Sister</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={`/mangarfamdygiinadmin/dare/Player/`} exact className="nav-link"  activeClassName="active">Player</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={`/mangarfamdygiinadmin/dare/Baby/`} exact className="nav-link"  activeClassName="active">Baby</NavLink>
                    </li>
                </ul>
                <div className="tab-content">
                    <Switch>
                        <Route exact path="/mangarfamdygiinadmin/dare/:dare/" component={Form}/>
                        <Route exact path="/mangarfamdygiinadmin/dare/:dare/:id/" component={FormUpdate}/>
                        <Route exact path="/mangarfamdygiinadmin/dare/:dare/add/" component={FormUpdate}/>
                    </Switch>
                </div>
            </div>
        </div>
        )

    }

}
